import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/storage-hub/capture-storage/database/$id/permissions")({
  staticData: {
    title: "common.permissions",
  },
});
